import { ConfigurationChoice, LanguageData, TestLanguage, TextOrientation } from "types/tests";
import {
  DYSLEXIA_LANGUAGE_VERSION_MAP,
  VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP,
} from "./testConstants/versionConstants";

export const nonSpecifiedLanguageData: LanguageData = {
  languageCode: TestLanguage.NOT_SPECIFIED,
  orientation: TextOrientation.L2R,
  translationKey: "notSpecified",
};

export const englishLanguageData: LanguageData = {
  languageCode: TestLanguage.English,
  orientation: TextOrientation.L2R,
  translationKey: "english",
};

export const turkishLanguageData: LanguageData = {
  languageCode: TestLanguage.Turkish,
  orientation: TextOrientation.L2R,
  translationKey: "turkish",
};

export const arabicLanguageData: LanguageData = {
  languageCode: TestLanguage.Arabic,
  orientation: TextOrientation.R2L,
  translationKey: "arabic",
};

export const frenchLanguageData: LanguageData = {
  languageCode: TestLanguage.French,
  orientation: TextOrientation.L2R,
  translationKey: "french",
};

export const czechLanguageData: LanguageData = {
  languageCode: TestLanguage.Czech,
  orientation: TextOrientation.L2R,
  translationKey: "czech",
};

export const germanLanguageData: LanguageData = {
  languageCode: TestLanguage.German,
  orientation: TextOrientation.L2R,
  translationKey: "german",
};

export const greekLanguageData: LanguageData = {
  languageCode: TestLanguage.Greek,
  orientation: TextOrientation.L2R,
  translationKey: "greek",
};

export const spanishLanguageData: LanguageData = {
  languageCode: TestLanguage.Spanish,
  orientation: TextOrientation.L2R,
  translationKey: "spanish",
};

export const persianLanguageData: LanguageData = {
  languageCode: TestLanguage.Persian,
  orientation: TextOrientation.R2L,
  translationKey: "persian",
};

export const italianLanguageData: LanguageData = {
  languageCode: TestLanguage.Italian,
  orientation: TextOrientation.L2R,
  translationKey: "italian",
};

export const japaneseLanguageData: LanguageData = {
  languageCode: TestLanguage.Japanese,
  orientation: TextOrientation.L2R,
  translationKey: "japanese",
};

export const koreanLanguageData: LanguageData = {
  languageCode: TestLanguage.Korean,
  orientation: TextOrientation.L2R,
  translationKey: "korean",
};

export const malayLanguageData: LanguageData = {
  languageCode: TestLanguage.Malay,
  orientation: TextOrientation.L2R,
  translationKey: "malay",
};

export const romanianLanguageData: LanguageData = {
  languageCode: TestLanguage.Romanian,
  orientation: TextOrientation.L2R,
  translationKey: "romanian",
};

export const swedishLanguageData: LanguageData = {
  languageCode: TestLanguage.Swedish,
  orientation: TextOrientation.L2R,
  translationKey: "swedish",
};

export const urduLanguageData: LanguageData = {
  languageCode: TestLanguage.Urdu,
  orientation: TextOrientation.R2L,
  translationKey: "urdu",
};

export const vietnameseLanguageData: LanguageData = {
  languageCode: TestLanguage.Vietnamese,
  orientation: TextOrientation.L2R,
  translationKey: "vietnamese",
};

export const chineseLanguageData: LanguageData = {
  languageCode: TestLanguage.Chinese,
  orientation: TextOrientation.L2R,
  translationKey: "chinese",
};

export const bulgarianLanguageData: LanguageData = {
  languageCode: TestLanguage.Bulgarian,
  orientation: TextOrientation.L2R,
  translationKey: "bulgarian",
};

export const danishLanguageData: LanguageData = {
  languageCode: TestLanguage.Danish,
  orientation: TextOrientation.L2R,
  translationKey: "danish",
};

export const hungarianLanguageData: LanguageData = {
  languageCode: TestLanguage.Hungarian,
  orientation: TextOrientation.L2R,
  translationKey: "hungarian",
};

export const norwegianBokmalLanguageData: LanguageData = {
  languageCode: TestLanguage.NorwegianBokmal,
  orientation: TextOrientation.L2R,
  translationKey: "norwegianBokmal",
};

export const dutchLanguageData: LanguageData = {
  languageCode: TestLanguage.Dutch,
  orientation: TextOrientation.L2R,
  translationKey: "dutch",
};

export const polishLanguageData: LanguageData = {
  languageCode: TestLanguage.Polish,
  orientation: TextOrientation.L2R,
  translationKey: "polish",
};

export const portugueseLanguageData: LanguageData = {
  languageCode: TestLanguage.Portuguese,
  orientation: TextOrientation.L2R,
  translationKey: "portuguese",
};

export const russianLanguageData: LanguageData = {
  languageCode: TestLanguage.Russian,
  orientation: TextOrientation.L2R,
  translationKey: "russian",
};

export const thaiLanguageData: LanguageData = {
  languageCode: TestLanguage.Thai,
  orientation: TextOrientation.L2R,
  translationKey: "thai",
};

export const latvianLanguageData: LanguageData = {
  languageCode: TestLanguage.Latvian,
  orientation: TextOrientation.L2R,
  translationKey: "latvian",
};

export const finnishLanguageData: LanguageData = {
  languageCode: TestLanguage.Finnish,
  orientation: TextOrientation.L2R,
  translationKey: "finnish",
};

export const indonesianLanguageData: LanguageData = {
  languageCode: TestLanguage.Indonesian,
  orientation: TextOrientation.L2R,
  translationKey: "indonesian",
};

export const LANGUAGE_DATA_MAP: Record<TestLanguage, LanguageData> = {
  [TestLanguage.NOT_SPECIFIED]: nonSpecifiedLanguageData,
  [TestLanguage.English]: englishLanguageData,
  [TestLanguage.Turkish]: turkishLanguageData,
  [TestLanguage.Arabic]: arabicLanguageData,
  [TestLanguage.French]: frenchLanguageData,
  [TestLanguage.Czech]: czechLanguageData,
  [TestLanguage.German]: germanLanguageData,
  [TestLanguage.Greek]: greekLanguageData,
  [TestLanguage.Spanish]: spanishLanguageData,
  [TestLanguage.Persian]: persianLanguageData,
  [TestLanguage.Italian]: italianLanguageData,
  [TestLanguage.Japanese]: japaneseLanguageData,
  [TestLanguage.Korean]: koreanLanguageData,
  [TestLanguage.Malay]: malayLanguageData,
  [TestLanguage.Romanian]: romanianLanguageData,
  [TestLanguage.Swedish]: swedishLanguageData,
  [TestLanguage.Urdu]: urduLanguageData,
  [TestLanguage.Vietnamese]: vietnameseLanguageData,
  [TestLanguage.Chinese]: chineseLanguageData,
  [TestLanguage.Bulgarian]: bulgarianLanguageData,
  [TestLanguage.Danish]: danishLanguageData,
  [TestLanguage.Hungarian]: hungarianLanguageData,
  [TestLanguage.NorwegianBokmal]: norwegianBokmalLanguageData,
  [TestLanguage.Dutch]: dutchLanguageData,
  [TestLanguage.Polish]: polishLanguageData,
  [TestLanguage.Portuguese]: portugueseLanguageData,
  [TestLanguage.Russian]: russianLanguageData,
  [TestLanguage.Thai]: thaiLanguageData,
  [TestLanguage.Latvian]: latvianLanguageData,
  [TestLanguage.Finnish]: finnishLanguageData,
  [TestLanguage.Indonesian]: indonesianLanguageData,
};

/**
 * Single source of truth for the virtual-assistant language dropdown.
 * Every test category that offers a virtual assistant renders its choices
 * from this list (ordered alphabetically, with NOT_SPECIFIED / "Don't show"
 * pinned first).
 *
 * Note: presence here only means the language is selectable. The actual
 * playback constraint is that the corresponding video assets must exist for
 * the selected language/video path ({language}/{videoName}.mp4); a missing
 * asset surfaces as a load error at runtime, not a config-time restriction.
 */
export const VIRTUAL_ASSISTANT_LANGUAGE_LIST: ConfigurationChoice<TestLanguage>[] = [
  {
    value: TestLanguage.NOT_SPECIFIED,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.NOT_SPECIFIED],
  },
  {
    value: TestLanguage.Arabic,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Arabic],
  },
  {
    value: TestLanguage.Bulgarian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Bulgarian],
  },
  {
    value: TestLanguage.Chinese,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Chinese],
  },
  {
    value: TestLanguage.Czech,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Czech],
  },
  {
    value: TestLanguage.Danish,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Danish],
  },
  {
    value: TestLanguage.Dutch,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Dutch],
  },
  {
    value: TestLanguage.English,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.English],
  },
  {
    value: TestLanguage.Finnish,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Finnish],
  },
  {
    value: TestLanguage.French,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.French],
  },
  {
    value: TestLanguage.German,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.German],
  },
  {
    value: TestLanguage.Greek,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Greek],
  },
  {
    value: TestLanguage.Hungarian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Hungarian],
  },
  {
    value: TestLanguage.Indonesian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Indonesian],
  },
  {
    value: TestLanguage.Italian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Italian],
  },
  {
    value: TestLanguage.Korean,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Korean],
  },
  {
    value: TestLanguage.Latvian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Latvian],
  },
  {
    value: TestLanguage.Malay,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Malay],
  },
  {
    value: TestLanguage.NorwegianBokmal,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.NorwegianBokmal],
  },
  {
    value: TestLanguage.Persian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Persian],
  },
  {
    value: TestLanguage.Polish,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Polish],
  },
  {
    value: TestLanguage.Portuguese,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Portuguese],
  },
  {
    value: TestLanguage.Romanian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Romanian],
  },
  {
    value: TestLanguage.Russian,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Russian],
  },
  {
    value: TestLanguage.Spanish,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Spanish],
  },
  {
    value: TestLanguage.Swedish,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Swedish],
  },
  {
    value: TestLanguage.Thai,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Thai],
  },
  {
    value: TestLanguage.Turkish,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Turkish],
  },
  {
    value: TestLanguage.Urdu,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Urdu],
  },
  {
    value: TestLanguage.Vietnamese,
    validSinceVersion: VIRTUAL_ASSISTANT_LANGUAGE_VERSION_MAP[TestLanguage.Vietnamese],
  },
];

export const DYSLEXIA_SUPPORTED_LANGUAGES: ConfigurationChoice<TestLanguage>[] = [
  {
    value: TestLanguage.English,
    validSinceVersion: DYSLEXIA_LANGUAGE_VERSION_MAP[TestLanguage.English],
  },
  {
    value: TestLanguage.Turkish,
    validSinceVersion: DYSLEXIA_LANGUAGE_VERSION_MAP[TestLanguage.Turkish],
  },
  {
    value: TestLanguage.Arabic,
    validSinceVersion: DYSLEXIA_LANGUAGE_VERSION_MAP[TestLanguage.Arabic],
  },
];

export const OSS_TUTORIAL_SUPPORTED_LANGUAGES: ConfigurationChoice<TestLanguage>[] = [
  { value: TestLanguage.English, validSinceVersion: null },
  { value: TestLanguage.Arabic, validSinceVersion: null },
];

export const READING_ASSESSMENT_SUPPORTED_LANGUAGES = DYSLEXIA_SUPPORTED_LANGUAGES;

// Every ISO 639-1 code, so a student's mother tongue can be recorded even when
// no test is available in it. Labels come from Intl.DisplayNames at runtime,
// see buildLanguageOptions in @utils/languageOptions.
export const ISO_639_1_LANGUAGE_CODES: string[] = (
  "aa ab ae af ak am an ar as av ay az ba be bg bh bi bm bn bo br bs ca ce ch " +
  "co cr cs cu cv cy da de dv dz ee el en eo es et eu fa ff fi fj fo fr fy ga " +
  "gd gl gn gu gv ha he hi ho hr ht hu hy hz ia id ie ig ii ik io is it iu ja " +
  "jv ka kg ki kj kk kl km kn ko kr ks ku kv kw ky la lb lg li ln lo lt lu lv " +
  "mg mh mi mk ml mn mr ms mt my na nb nd ne ng nl nn no nr nv ny oc oj om or " +
  "os pa pi pl ps pt qu rm rn ro ru rw sa sc sd se sg si sk sl sm sn so sq sr " +
  "ss st su sv sw ta te tg th ti tk tl tn to tr ts tt tw ty ug uk ur uz ve vi " +
  "vo wa wo xh yi yo za zh zu"
).split(" ");
